import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Animation, Button, Status } from '../../assets/global/globalStyles';
import Table from '../../components/Table';
import useFetch from '../../hooks/useFetch';
import { fetchOrderDetails } from '../../store/orderDetails';
import convertDate from '../../utils/convertDate';
import { WAREHOUSE_GROUPS } from '../../global/variables/userGroups';

export default function OrderDetails() {
  const { data: orderDetails } = useFetch(
    fetchOrderDetails({
      url: '/deliveryorder/delivery-orders-with-items',
      method: 'GET',
    }),
    'orderDetails',
  );
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();

  const dataUpdateObject = React.useMemo(() => {
    const orderType = {
      AAA: 'Pedido Recebido',
      CBA: 'Pedido em Separação',
      CBB: 'Pedido em Conferência',
      CCC: 'Pedido em Trânsito',
      APP: 'Pedido Entregue',
    };
    return orderDetails.map((item) => ({
      ...item,
      deliveredDate:
        item.deliveredDate === '1900-01-01T00:00:00' ||
        item.deliveredDate === '0001-01-01T00:00:00'
          ? null
          : convertDate(item.deliveredDate, false),
      deliveryDate:
        item.deliveryDate === '1900-01-01T00:00:00' ||
        item.deliveryDate === '0001-01-01T00:00:00'
          ? null
          : convertDate(item.deliveryDate, false),
      _: orderType[item.orderStatus],
    }));
  }, [orderDetails]);

  const seeOrder = ({ warehouseId, document, orderStatus, licensePlate }) => {
    navigate(
      `/dashboard/orderstatus?document=${document}&warehouseId=${warehouseId}&orderStatus=${orderStatus}&licensePlate=${licensePlate}`,
    );
  };

  const seeOrderMap = (document) => {
    navigate(`/dashboard/map?document=${document}`);
  };

  return (
    <Animation>
      <Table
        data={dataUpdateObject}
        title="Gerenciamento de Pedidos"
        keyStorage="orderdetails_filter"
        columns={[
          'document',
          'material',
          'description',
          'quantity',
          'unit',
          'warehouseCode',
          'warehouse',
          'deliveryDate',
          'deliveredDate',
          'orderStatus',
        ]}
        columnsStyles={{
          material: {
            whiteSpace: 'nowrap',
          },
        }}
        columnNames={[
          'Documento',
          'Material',
          'Descrição',
          'Qtd',
          'Un',
          user?.userGroup?.find(userGroup => WAREHOUSE_GROUPS.includes(userGroup))
          ? 'Depósito' : 'CD',
          'Código Depósito',
          'Previsão de entrega',
          'Entrega realizada',
          'Status',
        ]}
        columnsModify={{
          orderStatus: (value) => {
            const orderType = {
              AAA: <Status typeName="warning">Pedido Recebido</Status>,
              CBA: <Status typeName="orange">Pedido em Separação</Status>,
              CBB: <Status typeName="danger">Pedido em Conferência</Status>,
              CCC: <Status typeName="welcome">Pedido em Trânsito</Status>,
              APP: <Status typeName="success">Pedido Entregue</Status>,
              default: value,
            };
            return orderType[value] || orderType['default'];
          },
          deliveryDate: (value) => (value === '01/01/1 00:00' ? '' : value),
          deliveredDate: (value) => (value === '01/01/1 00:00' ? '' : value),
        }}
        columnButtons={[
          (data) => (
            <Button typeName="welcome" onClick={() => seeOrder(data)}>
              Ver
            </Button>
          ),
          ({ document, orderStatus, licensePlate }) => (
            <Button
              typeName="warning"
              onClick={() =>
                (orderStatus === 'CCC' || licensePlate === null) &&
                seeOrderMap(document)
              }
              disabled={orderStatus !== 'CCC' || licensePlate === null}
              cursor={
                orderStatus !== 'CCC' || licensePlate === null
                  ? 'not-allowed'
                  : null
              }
              title={
                orderStatus !== 'CCC' || licensePlate === null
                  ? 'Desabilitado'
                  : null
              }
            >
              Ver no mapa
            </Button>
          ),
        ]}
      />
    </Animation>
  );
}
